module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-1-sel.f560adb2.svg";